import { TaskTestSecurityPage } from './../pages/task-test-security/task-test-security';
import { TaskTestFirealarmPage } from './../pages/task-test-firealarm/task-test-firealarm';
import { TasksCompletePage } from './../pages/tasks-complete/tasks-complete';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { AppVersion } from '@ionic-native/app-version';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FCM } from '@ionic-native/fcm';
import { Loader } from '../theme/loader/loader';
import { TasksProvider } from '../providers/tasks/tasks';
import { AuthProvider } from '../providers/auth/auth';
import { DevicesProvider } from '../providers/devices/devices';
import { UtilsProvider } from '../providers/utils/utils';
import { LoginPage } from '../pages/login/login';
import { MaintenancePage } from '../pages/maintenance/maintenance';
import { TasksPage } from '../pages/tasks/tasks';
import { TaskCodePage } from '../pages/task-code/task-code';
import { TaskTestPage } from '../pages/task-test/task-test';
import { TaskCompletePage } from '../pages/task-complete/task-complete';
import { TaskQuestionsPage } from '../pages/task-questions/task-questions';
import { SupportPage } from '../pages/support/support';
import { UiProvider } from '../providers/ui/ui';
import { TypesFilter, StatusFilter } from '../providers/tasks/filters';
import { ProvidersProvider } from '../providers/providers/providers';
import { ControlsGeyserPage } from '../pages/controls-geyser/controls-geyser';
import { SocketProvider } from '../providers/socket/socket';

import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
  declarations: [
    MyApp,
    Loader,
    LoginPage,
    MaintenancePage,
    TasksPage,
    TasksCompletePage,
    TaskCodePage,
    TaskTestPage,
    TaskTestFirealarmPage,
    TaskTestSecurityPage,
    TaskCompletePage,
    TaskQuestionsPage,
    ControlsGeyserPage,
    SupportPage,
    TypesFilter,
    StatusFilter
  ],
  imports: [
    ZXingScannerModule,
    BrowserModule,
    ApolloModule,
    HttpClientModule,
    HttpLinkModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#488aff',
      innerStrokeColor: '#b6d0ff',
      animationDuration: 300
    }),
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(
      MyApp,
      {}
    )
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    MaintenancePage,
    TasksPage,
    TasksCompletePage,
    TaskCodePage,
    TaskTestPage,
    TaskTestFirealarmPage,
    TaskTestSecurityPage,
    TaskCompletePage,
    TaskQuestionsPage,
    ControlsGeyserPage,
    SupportPage
  ],
  providers: [
    StatusBar,
    Loader,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthProvider,
    TasksProvider,
    DevicesProvider,
    UtilsProvider,
    UtilsProvider,
    UiProvider,
    InAppBrowser,
    AppVersion,
    FCM,
    ProvidersProvider,
    SocketProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts